
export enum ToastSnackBarIcon {
    ICON_INFO = 'icon-info',
    ICON_TICK_CIRCLE = 'icon-tick-circle',
    ICON_WARNING = 'icon-Warning-important',
    ICON_ERROR_SEVERE = 'icon-error-severe',
}

export interface ToastSnackBarMessage {
    icon: ToastSnackBarIcon,
    message: string
}
